module.exports = __webpack_public_path__ + "static/media/35a22f96a2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/35.gif
// module id = 1245
// module chunks = 0